import { useState } from "react";

import { Box, Grid, Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

import { DefaultPaper, TextField } from "@aclymatepackages/atoms";

import Backdrop from "../../atoms/mui/Backdrop";

const watermarkSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="200"><text x="50%" y="50%" transform="rotate(-30 200 100)" text-anchor="middle" font-size="48" font-family="Arial" font-weight="bold" fill="rgba(180,0,0,0.12)" dominant-baseline="middle">PRELIMINARY</text></svg>`;
const watermarkBg = `url("data:image/svg+xml,${encodeURIComponent(watermarkSvg)}")`;

const SharedReportOverlay = ({
  reportUrl,
  year,
  companyName,
  title,
  isFinalized = true,
  onClose
}) => {
  const [reportName, setReportName] = useState(
    title || `${companyName} ${year} Emissions`
  );
  const [downloading, setDownloading] = useState(false);

  const onDownload = async () => {
    setDownloading(true);
    const response = await fetch(reportUrl);
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = `${reportName}.pdf`;
    link.click();
    URL.revokeObjectURL(objectUrl);
    setDownloading(false);
  };

  return (
    <Backdrop
      style={{ overflowY: "hidden", zIndex: 1300 }}
      onClose={onClose}
      boxStyle={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }}
    >
      <Box mb={2}>
        <DefaultPaper>
          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <TextField
                value={reportName}
                setValue={(value) => setReportName(`${value}`)}
                variant="standard"
                style={{ width: "450px" }}
                InputProps={{ endAdornment: ".pdf" }}
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                endIcon={<DownloadIcon />}
                onClick={onDownload}
                disabled={downloading || !isFinalized}
              >
                Download PDF
              </Button>
            </Grid>
          </Grid>
        </DefaultPaper>
      </Box>
      <Box flexGrow={1} style={{ overflow: "hidden", position: "relative" }}>
        <iframe
          src={`${reportUrl}#toolbar=0&navpanes=0`}
          style={{ width: "100%", height: "100%", border: "none" }}
          title="Emissions Report"
        />
        {!isFinalized && (
          <Box
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundImage: watermarkBg,
              backgroundRepeat: "repeat",
              pointerEvents: "none",
              zIndex: 1
            }}
          />
        )}
      </Box>
    </Backdrop>
  );
};

export default SharedReportOverlay;
